export const RESET = 'EXSBPRICEGROUP_UPDATE_RESET'
export const SET_ERROR = 'EXSBPRICEGROUP_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPRICEGROUP_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPRICEGROUP_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPRICEGROUP_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPRICEGROUP_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPRICEGROUP_UPDATE_UPDATE_RETRIEVED'
